import Link from "../Link";

const Swift = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/84" title={"OpenBootcamp Swift"} />
        </div>
    );
}

export default Swift;